export const FETCH_MANAGER_DASHBOARD = "FETCH_MANAGER_DASHBOARD";
export const FETCH_ADMIN_DASHBOARD = "FETCH_ADMIN_DASHBOARD";
export const FETCH_EMPLOYEE_PENDING_REQUESTS =
  "FETCH_EMPLOYEE_PENDING_REQUESTS";
export const FETCH_ESS_REMINDERS = "FETCH_ESS_REMINDERS";
export const FETCH_TODAY_ATTENDANCE_DASHBOARD =
  "FETCH_TODAY_ATTENDANCE_DASHBOARD";
export const FETCH_ATTENDANCE_DASHBOARD = "FETCH_ATTENDANCE_DASHBOARD";
export const FETCH_ATTENDANCE_TIMESHEET = "FETCH_ATTENDANCE_TIMESHEET";
export const FETCH_REMOTE_TIMESHEET = "FETCH_REMOTE_TIMESHEET";
export const APPROVE_REMOTE_TIMESHEET = "APPROVE_REMOTE_TIMESHEET";
export const REJECT_REMOTE_TIMESHEET = "REJECT_REMOTE_TIMESHEET";
export const FETCH_LATE_ARRIVAL = "FETCH_LATE_ARRIVAL";
export const FETCH_FAILED_ATTEMPTS = "FETCH_FAILED_ATTEMPTS";
export const APPROVE_FAILED_ATTEMPT = "APPROVE_FAILED_ATTEMPT";
export const REJECT_FAILED_ATTEMPT = "REJECT_FAILED_ATTEMPT";
